export default "__VITE_ASSET__4aafae4c__"